var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwaitingChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23275 1.93658C10.3196 1.93658 12.8219 4.43939 12.8219 7.5257C12.8219 10.612 10.3196 13.1148 7.23275 13.1148C4.14588 13.1148 1.64363 10.612 1.64363 7.5257C1.64363 4.43939 4.14588 1.93658 7.23275 1.93658ZM7.23275 2.86829C4.66455 2.86829 2.57534 4.9575 2.57534 7.5257C2.57534 10.0939 4.66455 12.1831 7.23275 12.1831C9.80095 12.1831 11.8902 10.0939 11.8902 7.5257C11.8902 4.9575 9.80095 2.86829 7.23275 2.86829ZM6.81356 4.17223C7.02567 4.17223 7.20115 4.33003 7.22892 4.53456L7.23275 4.59141V7.5257H9.04921C9.2806 7.5257 9.46839 7.71349 9.46839 7.94488C9.46839 8.15699 9.31059 8.33247 9.10606 8.36024L9.04921 8.36407H6.81356C6.60146 8.36407 6.42598 8.20627 6.39821 8.00174L6.39438 7.94488V4.59141C6.39438 4.36002 6.58217 4.17223 6.81356 4.17223Z",
    fill: "#49484D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaitingChange);
export default __webpack_public_path__ + "static/media/AwaitingChange.b25d5f07a6f2457ff2610af4077163bf.svg";
export { ForwardRef as ReactComponent };